// import React, { useState, useEffect } from "react";
// import Layout, { Container } from "../components/layout.js";
// import { useNavigate } from "react-router-dom";
// import { apiurl } from "../config/config.js";
// import { getCookie } from "../config/webStorage.js";
// import { useUser } from "../config/userProvider.js";
// import axios from "axios";

// export default function MaterialCreate() {
//   const navigation = useNavigate();
//   let token = getCookie("scspt");
//   const { userData } = useUser();

//   // const [suppliers, setSuppliers] = useState([]);
//   // const [searchTerm, setSearchTerm] = useState("");
//   // const [showDropdown, setShowDropdown] = useState(false);

//   // Fetch suppliers
//   // useEffect(() => {
//   //   axios
//   //     .get(`${apiurl}/api/supplier/get`, {
//   //       headers: { Authorization: `${token}` },
//   //     })
//   //     .then((res) => {
//   //       setSuppliers(res.data.data || []);
//   //     })
//   //     .catch((err) => console.error("Supplier fetch error:", err));
//   // }, [token]);

//   // Handle supplier select
//   // const handleSelectSupplier = (supplier) => {
//   //   setItem((prev) => ({ ...prev, supplier: supplier._id })); // store supplierId
//   //   setSearchTerm(supplier.name); // show supplier name in input
//   //   setShowDropdown(false);
//   // };

//   const [item, setItem] = useState({
//     materialType: "packaging_material",
//     name: "",
//     description: "",
//     category: "",
//     subCategory: "",
//     sku: "",
//     barcode: "",
//     image: "",
//     tags: "",
//     specifications: "",
//     unit: "",
//     quantity: "",
//     minStockLevel: "",
//     pricePerUnit: "",
//     supplier: "",
//     batches: [
//       { batchNumber: "", quantity: "", receivedDate: "", expiryDate: "" },
//     ],
//   });

//   const handleChange = (e) => {
//     const { name, value, type, files } = e.target;
//     setItem((prev) => ({
//       ...prev,
//       [name]: type === "file" ? files[0] : value,
//     }));
//   };

//   // const handleBatchChange = (index, e) => {
//   //   const { name, value } = e.target;
//   //   setItem((prev) => {
//   //     const updatedBatches = [...prev.batches];
//   //     updatedBatches[index][name] = value;
//   //     return { ...prev, batches: updatedBatches };
//   //   });
//   // };

//   // const addBatch = () => {
//   //   setItem((prev) => ({
//   //     ...prev,
//   //     batches: [
//   //       ...prev.batches,
//   //       { batchNumber: "", quantity: "", receivedDate: "", expiryDate: "" },
//   //     ],
//   //   }));
//   // };

//   // const removeBatch = (index) => {
//   //   setItem((prev) => ({
//   //     ...prev,
//   //     batches: prev.batches.filter((_, i) => i !== index),
//   //   }));
//   // };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const payload = {
//       ...item,
//       tags: item.tags.split(",").map((t) => t.trim()),
//       createdBy: {
//         userObjId: userData?._id,
//         userName: userData?.firstName + " " + userData?.lastName,
//         userId: userData?.id,
//         userDesignation: userData?.designation,
//         userDepartment: userData?.department,
//         createDate: new Date().toISOString(),
//       },
//     };

//     try {
//       const res = await fetch(`${apiurl}/api/material/create`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `${token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       if (!res.ok) throw new Error(`Error: ${res.status}`);

//       navigation("/materials");
//     } catch (error) {
//       console.error("Failed to create material:", error);
//     }
//   };

//   return (
//     <Layout>
//       <Container overflow="overflow-scroll">
//         <div className="mt-6 p-6 bg-white rounded shadow border border-gray-200 max-w-4xl mx-auto">
//           <h2 className="text-2xl font-semibold mb-6">Add Material</h2>

//           <form onSubmit={handleSubmit} className="space-y-8">
//             {/* Basic Info */}
//             <section>
//               <h3 className="text-lg font-medium mb-4">Basic Information</h3>
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block mb-1">Name</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={item.name}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label className="block mb-1">Material Type</label>
//                   <select
//                     name="materialType"
//                     value={item.materialType}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                   >
//                     <option value="packaging_material">
//                       Packaging Material
//                     </option>
//                     <option value="raw_material">Raw Material</option>
//                     {/* <option value="finished_material">Finished Material</option> */}
//                   </select>
//                 </div>
//                 <div className="sm:col-span-2">
//                   <label className="block mb-1">Description</label>
//                   <textarea
//                     name="description"
//                     value={item.description}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     rows={2}
//                   />
//                 </div>
//                 <div>
//                   <label className="block mb-1">SKU</label>
//                   <input
//                     type="text"
//                     name="sku"
//                     value={item.sku}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                   />
//                 </div>
//                 <div>
//                   <label className="block mb-1">Barcode</label>
//                   <input
//                     type="text"
//                     name="barcode"
//                     value={item.barcode}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                   />
//                 </div>
//                 <div>
//                   <label className="block mb-1">Upload Image</label>
//                   <input
//                     type="file"
//                     name="image"
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                   />
//                 </div>
//                 <div>
//                   <label className="block mb-1">Tags (comma separated)</label>
//                   <input
//                     type="text"
//                     name="tags"
//                     value={item.tags}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     placeholder="e.g. strong, light, durable"
//                   />
//                 </div>
//                 <div className="sm:col-span-2">
//                   <label className="block mb-1">Specifications</label>
//                   <textarea
//                     name="specifications"
//                     value={item.specifications}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     rows={2}
//                   />
//                 </div>
//               </div>
//             </section>

//             {/* Stock Details */}
//             <section>
//               <h3 className="text-lg font-medium mb-4">Stock Details</h3>
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block mb-1">Category</label>
//                   <select
//                     name="category"
//                     value={item.category}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                   >


//                   {item.materialType === 'packaging_material' ? (
//                     <>
//                       <option value="jar">Jar</option>
//                       <option value="tape">Tape</option>
//                       <option value="carton_box">Carton Box</option>
//                       <option value="spoon">Spoon</option>
//                       <option value="diet_chart">Diet Chart</option>
//                       <option value="shrink">Shrink</option>
//                       <option value="monocarton">Monocarton</option>
//                       <option value="label">Label</option>
//                       <option value="gel">Gel</option>
//                       <option value="bag">Bag</option>
//                       <option value="empty_capsule">Empty Capsule</option>
//                     </>
//                   ) : item.materialType === 'raw_material' ? (
//                     <>
//                     <option value="herb">Herb</option>
//                     <option value="powder">Powder</option>
//                     <option value="extract">Extract</option>
//                     <option value="chemical">Chemical</option>
//                     <option value="oil">Oil</option>
//                     <option value="juice">Juice</option>
//                     <option value="ghee">Ghee</option>
//                     </>
//                   ) : (
//                     <option value="finished_material">Finished Material</option>
//                   )}
//                   </select>
//                 </div>
//                 <div>
//                   <label className="block mb-1">Sub Category</label>
//                   <input
//                     type="text"
//                     name="subCategory"
//                     value={item.subCategory}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                   />
//                 </div>
//                 <div>
//                   <label className="block mb-1">Unit</label>
//                   <select
//                     name="unit"
//                     value={item.unit}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                   >
                  
//                     <option value="pcs">Piece</option>
//                     <option value="kg">Kilogram</option>
//                     <option value="ltr">Litre</option>
//                     <option value="mtr">Meter</option>
//                   </select>
//                 </div>
//                 {/* <div>
//                   <label className="block mb-1">Stock Status</label>
//                   <select
//                     name="stockStatus"
//                     value={item.stockStatus}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                   >
//                     <option value="in_stock">In Stock</option>
//                     <option value="out_of_stock">Out of Stock</option>
//                     <option value="low_stock">Low Stock</option>
//                   </select>
//                 </div> */}
//                 {/* <div>
//                   <label className="block mb-1">Quantity</label>
//                   <input
//                     type="number"
//                     name="quantity"
//                     value={item.quantity}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     required
//                   />
//                 </div> */}
//                 <div>
//                   <label className="block mb-1">Minimum Stock Level</label>
//                   <input
//                     type="number"
//                     name="minStockLevel"
//                     value={item.minStockLevel}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                   />
//                 </div>
//                 {/* <div>
//                   <label className="block mb-1">Price per Unit</label>
//                   <input
//                     type="number"
//                     name="pricePerUnit"
//                     value={item.pricePerUnit}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     required
//                   />
//                 </div> */}
//                 {/* Supplier Search Select */}
//                 {/* <div className="relative">
//                   <label className="block mb-1 font-medium">Supplier</label>
//                   <input
//                     type="text"
//                     value={searchTerm}
//                     onChange={(e) => {
//                       setSearchTerm(e.target.value);
//                       setShowDropdown(true);
//                     }}
//                     onFocus={() => setShowDropdown(true)}
//                     placeholder="Search supplier..."
//                     className="w-full p-2 border rounded"
//                   />
//                   {showDropdown && (
//                     <ul className="absolute z-10 w-full bg-white border rounded mt-1 max-h-48 overflow-y-auto shadow">
//                       {suppliers
//                         .filter((s) =>
//                           s.name
//                             .toLowerCase()
//                             .includes(searchTerm.toLowerCase())
//                         )
//                         .map((supplier) => (
//                           <li
//                             key={supplier._id}
//                             onClick={() => handleSelectSupplier(supplier)}
//                             className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
//                           >
//                             {supplier.name}{" "}
//                             <span className="text-sm text-gray-500">
//                               ({supplier.email || "No email"})
//                             </span>
//                           </li>
//                         ))}
//                       {suppliers.filter((s) =>
//                         s.name.toLowerCase().includes(searchTerm.toLowerCase())
//                       ).length === 0 && (
//                         <li className="px-3 py-2 text-gray-500">
//                           No supplier found
//                         </li>
//                       )}
//                     </ul>
//                   )}
//                 </div> */}
//               </div>
//             </section>

//             {/* Batches */}
//             {/* <section>
//               <h3 className="text-lg font-medium mb-4">Batches</h3>
//               {item.batches.map((batch, index) => (
//                 <div
//                   key={index}
//                   className="grid grid-cols-1 sm:grid-cols-5 gap-4 items-end mb-4 border p-4 rounded"
//                 >
//                   <input
//                     type="text"
//                     name="batchNumber"
//                     placeholder="Batch No."
//                     value={batch.batchNumber}
//                     onChange={(e) => handleBatchChange(index, e)}
//                     className="p-2 border rounded"
//                   />
//                   <input
//                     type="number"
//                     name="quantity"
//                     placeholder="Quantity"
//                     value={batch.quantity}
//                     onChange={(e) => handleBatchChange(index, e)}
//                     className="p-2 border rounded"
//                   />
//                   <input
//                     type="date"
//                     name="receivedDate"
//                     value={batch.receivedDate}
//                     onChange={(e) => handleBatchChange(index, e)}
//                     className="p-2 border rounded"
//                   />
//                   <input
//                     type="date"
//                     name="expiryDate"
//                     value={batch.expiryDate}
//                     onChange={(e) => handleBatchChange(index, e)}
//                     className="p-2 border rounded"
//                   />
//                   {item.batches.length > 1 && (
//                     <button
//                       type="button"
//                       onClick={() => removeBatch(index)}
//                       className="text-red-500 hover:underline"
//                     >
//                       Remove
//                     </button>
//                   )}
//                 </div>
//               ))}
//               <button
//                 type="button"
//                 onClick={addBatch}
//                 className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
//               >
//                 + Add Batch
//               </button>
//             </section> */}

//             {/* Actions */}
//             <div className="flex justify-end gap-2">
//               <button
//                 type="button"
//                 onClick={() => navigation("/materials")}
//                 className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="px-4 py-2 bg-[#4B49AC] text-white rounded hover:bg-indigo-700"
//               >
//                 Add Item
//               </button>
//             </div>
//           </form>
//         </div>
//       </Container>
//     </Layout>
//   );
// }
import React, { useState } from "react";
import Layout, { Container } from "../components/layout.js";
import { useNavigate } from "react-router-dom";
import { apiurl } from "../config/config.js";
import { getCookie } from "../config/webStorage.js";
import { useUser } from "../config/userProvider.js";

export default function MaterialCreate() {
  const navigate = useNavigate();
  const token = getCookie("scspt");
  const { userData } = useUser();

  /* ================= STATE ================= */
  const [item, setItem] = useState({
    materialType: "packaging_material",
    name: "",
    description: "",
    category: "",
    subCategory: "",
    sku: "",
    barcode: "",
    image: "",
    tags: "",
    specifications: "",
    unit: "",
    minStockLevel: "",
  });

  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);

  /* ================= HANDLERS ================= */
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setItem((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));

    // clear error on change
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  /* ================= VALIDATION ================= */
  const validateForm = () => {
    const newErrors = {};

    if (!item.name.trim()) {
      newErrors.name = "Material name is required";
    }

    if (!item.unit) {
      newErrors.unit = "Unit is required";
    }

    if (item.minStockLevel === "" || Number(item.minStockLevel) < 0) {
      newErrors.minStockLevel = "Minimum stock level is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");

    if (!validateForm()) {
      setFormError("Please fix the errors below");
      return;
    }

    setLoading(true);

    const payload = {
      ...item,
      minStockLevel: Number(item.minStockLevel),
      tags: item.tags ? item.tags.split(",").map((t) => t.trim()) : [],
      createdBy: {
        userObjId: userData?._id,
        userName: `${userData?.firstName} ${userData?.lastName}`,
        userId: userData?.id,
        userDesignation: userData?.designation,
        userDepartment: userData?.department,
        createDate: new Date().toISOString(),
      },
    };

    try {
      const res = await fetch(`${apiurl}/api/material/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed to create material");

      navigate("/materials");
    } catch (err) {
      console.error(err);
      setFormError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  /* ================= UI ================= */
  return (
    <Layout>
      <Container overflow="overflow-scroll">
        <div className="max-w-4xl mx-auto bg-white mt-6 p-6 rounded shadow border">
          <h2 className="text-2xl font-semibold mb-4">Add Material</h2>

          {formError && (
            <div className="mb-4 p-3 bg-red-50 text-red-700 border border-red-200 rounded">
              {formError}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-8">
            {/* ================= BASIC INFO ================= */}
            <section>
              <h3 className="font-medium mb-3">Basic Information</h3>
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label>Name *</label>
                  <input
                    name="name"
                    value={item.name}
                    onChange={handleChange}
                    className={`w-full p-2 border rounded ${
                      errors.name ? "border-red-500" : ""
                    }`}
                  />
                  {errors.name && (
                    <p className="text-sm text-red-500">{errors.name}</p>
                  )}
                </div>

                <div>
                  <label>Material Type</label>
                  <select
                    name="materialType"
                    value={item.materialType}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                  >
                    <option value="packaging_material">
                      Packaging Material
                    </option>
                    <option value="raw_material">Raw Material</option>
                  </select>
                </div>

                <div className="sm:col-span-2">
                  <label>Description</label>
                  <textarea
                    name="description"
                    value={item.description}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    rows={2}
                  />
                </div>
              </div>
            </section>

            {/* ================= STOCK INFO ================= */}
            <section>
              <h3 className="font-medium mb-3">Stock Details</h3>
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label>Category</label>
                  <select
                    name="category"
                    value={item.category}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                  >
                    {item.materialType === "packaging_material" ? (
                      <>
                        <option value="">Select</option>
                        <option value="jar">Jar</option>
                        <option value="label">Label</option>
                        <option value="bag">Bag</option>
                        <option value="carton_box">Carton Box</option>
                      </>
                    ) : (
                      <>
                        <option value="">Select</option>
                        <option value="herb">Herb</option>
                        <option value="powder">Powder</option>
                        <option value="extract">Extract</option>
                      </>
                    )}
                  </select>
                </div>

                <div>
                  <label>Sub Category</label>
                  <input
                    name="subCategory"
                    value={item.subCategory}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                  />
                </div>

                <div>
                  <label>Unit *</label>
                  <select
                    name="unit"
                    value={item.unit}
                    onChange={handleChange}
                    className={`w-full p-2 border rounded ${
                      errors.unit ? "border-red-500" : ""
                    }`}
                  >
                    <option value="">Select Unit</option>
                    <option value="pcs">Piece</option>
                    <option value="kg">Kilogram</option>
                    <option value="ltr">Litre</option>
                    <option value="mtr">Meter</option>
                  </select>
                  {errors.unit && (
                    <p className="text-sm text-red-500">{errors.unit}</p>
                  )}
                </div>

                <div>
                  <label>Minimum Stock Level *</label>
                  <input
                    type="number"
                    name="minStockLevel"
                    value={item.minStockLevel}
                    onChange={handleChange}
                    className={`w-full p-2 border rounded ${
                      errors.minStockLevel ? "border-red-500" : ""
                    }`}
                  />
                  {errors.minStockLevel && (
                    <p className="text-sm text-red-500">
                      {errors.minStockLevel}
                    </p>
                  )}
                </div>
              </div>
            </section>

            {/* ================= ACTIONS ================= */}
            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={() => navigate("/materials")}
                className="px-4 py-2 bg-gray-200 rounded"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-4 py-2 bg-[#4B49AC] text-white rounded hover:bg-indigo-700 disabled:opacity-60"
              >
                {loading ? "Saving..." : "Add Material"}
              </button>
            </div>
          </form>
        </div>
      </Container>
    </Layout>
  );
}